import { useState, useEffect } from 'react';
import { getAcknowledgementUpdates } from '../utils/httpUtils';
import { ACK_STATUS } from '../constants/constants';

/**
 * @name useAssociateAckDetails
 * @type CustomHook
 * @param {String} transactionId Unique transactionId for the request
 * @param {Function} setRequestState Set state function from the component
 * @description To connect with AANS long polling API to retrieve ack status and associate details
 */
export const useAssociateAckDetails = (transactionId, setRequestState, requestStateAfterAck) => {
  const [associateName, setAssociateName] = useState('');

  useEffect(() => {
    if (!transactionId) return;
    getAcknowledgementUpdates(transactionId)
      .then((response) => {
        const { status, associateDetails } = response;
        if (status === ACK_STATUS.ACKNOWLEDGED) {
          setAssociateName(associateDetails.associateName);
          setRequestState(requestStateAfterAck);
        }
      })
      .catch(() => {
      });
  }, [transactionId, setRequestState, requestStateAfterAck]);

  return [associateName];
};
